import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-white py-1 px-2 font-bold", _ctx.getColoreStato(_ctx.stato)])
  }, _toDisplayString(_ctx.getLabelStato(_ctx.stato)), 3))
}